import { ReactNode } from "react";
import { Container } from "./styles";
interface ListCardBoxProps {
  children: ReactNode;
  className?: string;
  style?: Object;
  rest?: string[];
}

export const ListCardBox = ({
  children,
  className,
  style,
  ...rest
}: ListCardBoxProps) => {
  return (
    <Container style={style} className={className} {...rest}>
      {children}
    </Container>
  );
};
